// extracted by mini-css-extract-plugin
module.exports = {"learnWrapper":"Learn_learnWrapper__xQhg1","learn":"Learn_learn___B1UP","actionCard":"Learn_actionCard__syEaB","image":"Learn_image__zdZ6H"};